import { FilterGroup, FilterInput } from '../constants';
import {
  hasWildcardChars,
  isIdentChipQuickSearchField,
  legacyFilterToChipValue,
} from './animalIdentChipFilter';

const AI_IDENTIFIER_OPERATORS = new Set([
  '',
  'EQUALS',
  'STARTS_WITH',
  'CONTAINS',
  'ENDS_WITH',
]);

/** Only these operators have an equivalent positive identifier-chip pattern. */
export function canNormalizeAiIdentifierFilter(
  operator: string,
  value: string,
): boolean {
  return (
    AI_IDENTIFIER_OPERATORS.has(operator) &&
    (!operator || (!hasWildcardChars(value) && !value.includes(',')))
  );
}

/**
 * Convert supported composite/identifier comparisons to equivalent chip values.
 * Exact column identities and unsupported operators must keep their meaning.
 */
export function normalizeAiSearchFilter(filter: FilterInput): FilterInput {
  const field = (filter.field ?? '').trim();

  if (isIdentChipQuickSearchField(field)) {
    const rawValue = filter.value ?? '';
    if (!canNormalizeAiIdentifierFilter(filter.operator, rawValue))
      return { ...filter, field };
    const value =
      filter.operator && !hasWildcardChars(rawValue)
        ? legacyFilterToChipValue(filter.operator, rawValue)
        : rawValue;
    return { field, operator: '', value };
  }

  return { ...filter, field };
}

export function normalizeAiSearchFilterGroups(
  filterGroups: FilterGroup[],
): FilterGroup[] {
  return filterGroups.map((group) => ({
    ...group,
    filters: group.filters.map(normalizeAiSearchFilter),
  }));
}
